import {Component, OnInit} from '@angular/core';
import {NavigationItem} from 'features/core/shared/dto/navigation/navigation-item';
import {ObjectBaseModeComponent} from 'features/core/shared/object/mvs-object-base/object-base-mode.component';

/**
 * Base-mode component of the Provisionsmatrix OBC (layer 2 of the three-layer pattern).
 *
 * Exact shape of `cp-provision-contract-agent-object/view/base/…`: a component WITHOUT a template
 * of its own (`template: ''`) that declares only the `navigationItems`; `full` and `side` inherit
 * from it. Because the class is never rendered itself it deliberately has NO .html/.scss.
 *
 * `ObjectBaseModeComponent` subscribes to `?navItem=` / `?sideNavItem=` on its own, so nothing has
 * to be rebuilt here.
 *
 * EXACTLY ONE navigation item, and that is the point of the whole component: the user asked for a
 * simple surface — the matrix header, then its rows. A second navItem would have to invent a
 * question the entity cannot answer; `cp.ProvisionTypeMatrix` owns exactly ONE same-module child
 * (`cp.ProvisionTypeMatrixAgent`), and the assignment rules pointing AT a matrix already have
 * their own surface on the ProvisionType OBC ("Matrizen" / "Matrix-Zuordnung"). The item is
 * declared all the same, because the frame renders the object header from it and `?navItem=`
 * deep links have to resolve to something.
 */
@Component({
    selector: 'cp-provision-type-matrix-base',
    template: '',
    standalone: false
})
export class CpProvisionTypeMatrixBaseComponent extends ObjectBaseModeComponent implements OnInit {

    /**
     * Navigation items of the Provisionsmatrix. `action` (not `route`) is the key — it is matched
     * against `?navItem=`.
     */
    navigationItems: NavigationItem[] = [
        {
            label: 'Übersicht',
            action: 'overview',
            tooltip: 'Kopfdaten der Provisionsmatrix und die Matrixzeilen, die sie enthält',
            icon: 'fa-regular fa-table-cells',
            toggleable: false,
            default: true
        }
    ];

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }

}
